import { Button } from '@mantine/core';

interface SendEmailButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export const SendEmailButton = ({ onClick, disabled }: SendEmailButtonProps) => {
    return (
        <Button 
            type="button" 
            onClick={onClick}
            disabled={disabled}
        >
            Send Email
        </Button>
    );
};
